import { render, staticRenderFns } from "./BuyProxy.vue?vue&type=template&id=16cfca33&scoped=true"
import script from "./BuyProxy.vue?vue&type=script&lang=js"
export * from "./BuyProxy.vue?vue&type=script&lang=js"
import style0 from "./BuyProxy.vue?vue&type=style&index=0&id=16cfca33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cfca33",
  null
  
)

export default component.exports